import { render, staticRenderFns } from "./process-data-disposal-period-form.vue?vue&type=template&id=c57ce2b2"
import script from "./process-data-disposal-period-form.vue?vue&type=script&lang=js"
export * from "./process-data-disposal-period-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports